import { createClient } from "@supabase/supabase-js"

// 使用浏览器内置的 localStorage 作为存储介质
const storage = typeof window !== "undefined" ? window.localStorage : undefined;


export const supabase = createClient(
  process.env.PLASMO_PUBLIC_SUPABASE_URL || "https://nxdmbfwgqtjigfchuski.supabase.co",
  process.env.PLASMO_PUBLIC_SUPABASE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54ZG1iZndncXRqaWdmY2h1c2tpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgwNzExOTksImV4cCI6MjAzMzY0NzE5OX0.r79Vu1Hk3djMz2WMy33k8Xrav_V7o33mWLxGufDuDs4",
  {
    auth: {
      // 使用同步的 localStorage 存储 session
      storage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce'
    },
  }
)
